import { createContext } from 'react';


interface JobFormContextProps {
  isLoading: boolean;
  showForm: boolean;
  errorMessage: string;
  openForm: () => void;
  closeForm: () => void;
}

export const JobFormContext = createContext<JobFormContextProps>({
    isLoading: false,
    showForm: false,
    errorMessage: '',
    closeForm: () => {},
    openForm: () => {}

});